import type {UpdateUserFormPayload} from "./update-user.schema";

import {updateUser} from "@project/sdk/admin";
import {mutationOptions} from "@tanstack/react-query";

import {userMutationKeys} from "../../user-keys";

import {updateUserMapper} from "./update-user.mapper";

/**
 * Mutation option factory for updating a user.
 *
 * Declares the mutationKey (for DevTools + setMutationDefaults targeting) and
 * the mutationFn. Optimistic logic (onMutate / onError / onSuccess) belongs in
 * the UI layer alongside useQueryClient().
 *
 * Usage in a component:
 *   const mutation = useMutation({
 *     ...updateUserMutationOptions(userId),
 *     onMutate: async (params) => { ... },
 *   });
 *
 * @param userId - The ID of the user being updated
 */
export function updateUserMutationOptions(userId: string) {
  return mutationOptions({
    mutationFn: (payload: UpdateUserFormPayload) => {
      const request = updateUserMapper.toSdk(payload);

      return updateUser(userId, request);
    },
    mutationKey: userMutationKeys.update(),
  });
}
